import Dialog from '@mui/material/Dialog';
import MuiButton from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { FCX } from '@core/models';
import Button from '@components/Button';
import { SurveyDetailsItem } from '@core/api/useSurveys';
import { getFormattedThousand } from '@core/utils/string';

export enum BulkItemsAction {
    ADD='add',
    REMOVE='remove',
}

const BulkItemsConfirmPopup: FCX<{
    open: boolean;
    onBulkItemsConfirm: () => void;
    handleClosePopup: () => void;
    items: SurveyDetailsItem[];
    action: BulkItemsAction,
}> = ({
    open,
    onBulkItemsConfirm,
    handleClosePopup,
    items,
    action,
}) => {

    return (
        <Dialog open={open} onClose={() => handleClosePopup()}>
            <DialogTitle>Bulk {action} items</DialogTitle>
            <DialogContent dividers>Are you sure you want to <strong>{action} {getFormattedThousand(items.length)}</strong> items?</DialogContent>
            <DialogActions>
                <MuiButton color="inherit" onClick={handleClosePopup}>
                    Cancel
                </MuiButton>
                <Button onClick={onBulkItemsConfirm}>Confirm</Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkItemsConfirmPopup;
